import { fetchJSON as fetchAPI } from './client';

const BASE = import.meta.env.VITE_PLUGINPLATFORM_API ?? 'http://localhost:8162';

export type PlatformDashboard = {
  total_plugins: number;
  installed_plugins: number;
  active_plugins: number;
  marketplace_count: number;
  publisher_count: number;
  total_downloads: number;
  avg_rating: number;
  recent_activity?: ActivityEntry[];
};

export type ActivityEntry = {
  id: string;
  tenant_id: string;
  action: string;
  resource: string;
  details?: string;
  actor: string;
  created_at: string;
};

export type PluginRecord = {
  id: string;
  plugin_id: string;
  name: string;
  version: string;
  category: string;
  state: string;
  licensed: boolean;
  health: { status: string; checked_at: string };
  installed_at?: string;
};

export type MarketplaceListing = {
  id: string;
  plugin_id: string;
  name: string;
  description?: string;
  version: string;
  category: string;
  publisher_name?: string;
  rating: number;
  review_count: number;
  downloads: number;
  price_cents: number;
  featured?: boolean;
  tags?: string[];
};

export type PublisherProfile = {
  id: string;
  name: string;
  company?: string;
  website?: string;
  verified: boolean;
  plugin_count: number;
};

function headers() {
  return { 'X-Tenant-ID': 'default', 'X-Organization-ID': 'default' };
}

export const pluginPlatformApi = {
  dashboard: () => fetchAPI<PlatformDashboard>(`${BASE}/api/v1/plugins/dashboard`, { headers: headers() }),
  listPlugins: () => fetchAPI<{ plugins: PluginRecord[] }>(`${BASE}/api/v1/plugins`, { headers: headers() }),
  getPlugin: (id: string) => fetchAPI<PluginRecord>(`${BASE}/api/v1/plugins/${id}`, { headers: headers() }),
  install: (pluginId: string, version?: string) =>
    fetchAPI<PluginRecord>(`${BASE}/api/v1/plugins/install`, { method: 'POST', headers: headers(), body: JSON.stringify({ plugin_id: pluginId, version }) }),
  upgrade: (pluginId: string, version: string) =>
    fetchAPI<PluginRecord>(`${BASE}/api/v1/plugins/upgrade`, { method: 'POST', headers: headers(), body: JSON.stringify({ plugin_id: pluginId, version }) }),
  disable: (pluginId: string) =>
    fetchAPI<PluginRecord>(`${BASE}/api/v1/plugins/disable`, { method: 'POST', headers: headers(), body: JSON.stringify({ plugin_id: pluginId }) }),
  uninstall: (pluginId: string) =>
    fetchAPI<{ status: string }>(`${BASE}/api/v1/plugins/uninstall`, { method: 'POST', headers: headers(), body: JSON.stringify({ plugin_id: pluginId }) }),
  marketplace: (category?: string) =>
    fetchAPI<{ listings: MarketplaceListing[] }>(`${BASE}/api/v1/plugins/marketplace${category ? `?category=${category}` : ''}`, { headers: headers() }),
  publishers: () => fetchAPI<{ publishers: PublisherProfile[] }>(`${BASE}/api/v1/plugins/publishers`, { headers: headers() }),
  reviews: (pluginId: string) =>
    fetchAPI<{ reviews: unknown[] }>(`${BASE}/api/v1/plugins/reviews?plugin_id=${encodeURIComponent(pluginId)}`, { headers: headers() }),
};
